<dx-data-grid
  class="sollstellungen-datagrid"
  #sollstellungenDataGrid
  [dataSource]="dataSource"
  height="auto"
  [columnAutoWidth]="true"
  [rowAlternationEnabled] = 'false'
  (onSelectionChanged)="onSelectionChanged($event)"
  (onToolbarPreparing)="onToolbarPreparing($event)"
  (onContentReady)="onContentReady($event)"
  (onCellPrepared)="onCellPrepared($event)">

  <dxo-search-panel [width]="300" [visible]="true"></dxo-search-panel>
  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <!-- <dxo-grouping #expand [autoExpandAll]="false" expandMode="rowClick"></dxo-grouping> -->

  <dxi-column dataField="buchung.datum" caption="Erstellt am" dataType="date" format="dd.MM.yyyy hh:mm" [allowSorting]="true"></dxi-column>
  <!-- <dxi-column dataField="dummy" caption="Monat" [allowSorting]="false"></dxi-column> -->
  <dxi-column dataField="monat" caption="Leistungsmonat" [calculateCellValue]="calculateMonatJahr" [allowSorting]="true">
  </dxi-column>
  @if (type==='haushalt') {
    <dxi-column dataField="buchung.kind" caption="Kind" [allowSorting]="false"></dxi-column>
  }
  <!-- <dxi-column dataField="betreuungsumfang" caption="Betreuungsumfang" [customizeText]="customizeTextBlank" [allowSorting]="false"></dxi-column> -->
  <!-- <dxi-column dataField="einkommen" caption="Einkommen" dataType="number" format="#,##0.00 €" [customizeText]="customizeTextBlank" [allowSorting]="false"></dxi-column> -->
  <dxi-column dataField="buchung.betragTyp" caption="Beitragstyp" [allowSorting]="true"></dxi-column>
  <!-- <dxi-column dataField="buchung.soll" caption="Berechnet (Soll)" dataType="number" format="#,##0.00 €" [customizeText]="customizeTextBlank" [allowSorting]="false"></dxi-column> -->
  <dxi-column dataField="buchung.einnahmeart" caption="Einnahmeart" [allowSorting]="true"></dxi-column>
  <dxi-column dataField="buchung.ist" caption="Gebucht" dataType="number" format="#,##0.00 €" [allowSorting]="false"></dxi-column>
  <!-- <dxi-column dataField="buchung.diff" caption="Differenz" dataType="number" format="#,##0.00 €" [allowSorting]="false"></dxi-column> -->


  <!-- <div *dxTemplate="let d of 'diffCellTemplateEB'"
  [class]="d.data.buchung.diff === 0 ? 'null' : (d.data.buchung.diff > 0 ? 'inc' : 'dec')">
  <div class="diff">{{ abs(d.data.buchung.diff) | currency : "EUR" : 'symbol' : "1.2-2" : "de-DE"}}
  </div>
</div>
<div *dxTemplate="let d of 'diffGroupTemplateEB'">
  <div class="diff">{{ d.value}}
  </div>
</div>   -->
</dx-data-grid>

<!-- <dx-data-grid
class="sollstellungen-datagrid"
#sollstellungenDataGrid
[dataSource]="dataSource"
height="auto"
[columnAutoWidth]="true"
[rowAlternationEnabled] = 'false'
(onSelectionChanged)="onSelectionChanged($event)"
(onToolbarPreparing)="onToolbarPreparing($event)"
(onContentReady)="onContentReady($event)"
(onCellPrepared)="onCellPrepared($event)">

<dxo-search-panel [width]="300" [visible]="true"></dxo-search-panel>
<dxo-grouping #expand [autoExpandAll]="false" expandMode="rowClick"></dxo-grouping>

<dxi-column dataField="dummy" caption="Monat" [allowSorting]="false"></dxi-column>
<dxi-column dataField="monat" caption="Monat" [calculateCellValue]="calculateMonatJahr" [groupIndex]="0" groupCellTemplate="diffGroupTemplateEB" [allowSorting]="false">
</dxi-column>
<dxi-column *ngIf="type==='haushalt'" dataField="buchung.kind" caption="Kind" [groupIndex]="1" [allowSorting]="false"></dxi-column>
<dxi-column dataField="betreuungsumfang" caption="Betreuungsumfang" [customizeText]="customizeTextBlank" [allowSorting]="false"></dxi-column>
<dxi-column dataField="einkommen" caption="Einkommen" dataType="number" format="#,##0.00 €" [customizeText]="customizeTextBlank" [allowSorting]="false"></dxi-column>
<dxi-column dataField="buchung.betragTyp" caption="Beitragstyp" [allowSorting]="false" [groupIndex]="2"></dxi-column>
<dxi-column dataField="buchung.datum" caption="Erstellt am" dataType="date" format="dd.MM.yyyy hh:mm" [allowSorting]="true"></dxi-column>
<dxi-column dataField="buchung.soll" caption="Berechnet (Soll)" dataType="number" format="#,##0.00 €" [customizeText]="customizeTextBlank" [allowSorting]="false"></dxi-column>
<dxi-column dataField="buchung.ist" caption="Gebucht (Ist)" dataType="number" format="#,##0.00 €" [allowSorting]="false"></dxi-column>
<dxi-column dataField="buchung.diff" caption="Differenz" dataType="number" format="#,##0.00 €" [allowSorting]="false"></dxi-column>

<dxo-summary [calculateCustomSummary]="calculateSummary">
  <dxi-group-item
    name="betreuungsumfang"
    column="betreuungsumfang"
    summaryType="custom"
    [showInGroupFooter]="false"
    [alignByColumn]="true"
    displayFormat="{0}"
    >
  </dxi-group-item>
  <dxi-group-item
    name="einkommen"
    column="einkommen"
    summaryType="custom"
    valueFormat="#,##0.00 €"
    [showInGroupFooter]="false"
    [alignByColumn]="true"
    displayFormat="{0}"
    >
  </dxi-group-item>
  <dxi-group-item
    name="beitragstyp"
    column="buchung.betragTyp"
    summaryType="custom"
    [showInGroupFooter]="false"
    [alignByColumn]="true"
    displayFormat="{0}"
    >
  </dxi-group-item>
  <dxi-group-item
    name="soll"
    column="buchung.soll"
    summaryType="custom"
    valueFormat="#,##0.00 €"
    [showInGroupFooter]="false"
    [alignByColumn]="true"
    displayFormat="{0}"
    >
  </dxi-group-item>
  <dxi-group-item
    column="buchung.ist"
    summaryType="sum"
    valueFormat="#,##0.00 €"
    [showInGroupFooter]="false"
    [alignByColumn]="true"
    displayFormat="{0}"
    >
  </dxi-group-item>
  <dxi-group-item
    column="buchung.diff"
    summaryType="sum"
    valueFormat="#,##0.00 €"
    [showInGroupFooter]="false"
    [alignByColumn]="true"
    displayFormat="{0}"
    >
  </dxi-group-item>
</dxo-summary>
<div *dxTemplate="let d of 'diffCellTemplateEB'"
  [class]="d.data.buchung.diff === 0 ? 'null' : (d.data.buchung.diff > 0 ? 'inc' : 'dec')">
  <div class="diff">{{ abs(d.data.buchung.diff) | currency : "EUR" : 'symbol' : "1.2-2" : "de-DE"}}
  </div>
</div>
<div *dxTemplate="let d of 'diffGroupTemplateEB'">
  <div class="diff">{{ d.value}}
  </div>
</div>
</dx-data-grid> -->